// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const MessageContract = contract({
  name: "Message",
  description: "The canonical \"avatar + author + timestamp + body\" row. THE PRIMITIVE\nfor any chat surface, comment thread, post-reply, activity log, or\nnotification feed that follows the people-and-text shape.\n\nCONCRETE TEST — if you find yourself composing an `<Avatar>` followed\nby a `<Row>` of author name + timestamp, with a `<p>` or `<span>`\nbody below, STOP. That is `<Message>`. Reach for it directly.\n\nSlack-style channel feed, Discord messages, Teams chat, Linear /\nGitHub / Jira comments, Reddit replies, Twitter/X posts in a thread,\nNotion comment sidebars, in-app activity logs, notification rows —\nevery one of these IS `<Message>`. Do not roll the layout inline.\n\nFor non-people activity (system events, log lines, status pings) use\nCallout or a plain Row instead — Message implies a human author.",
  import: "@gradeui/ui",
  composesWith: ["Avatar (in the avatar slot — pair with AvatarFallback tone=\"...\" for stable per-author colour)","Badge (in the badge slot for role / OP / bot tags)","Button (in actions","typically size=\"icon\" + variant=\"ghost\")","Stack (host multiple Messages in a thread)","Card (wrap a Stack of Messages for a comment-thread block)"],
  styleDefaults: {"Message":"flex items-start"},
  props: {
  "author": {
      schema: z.string(),
      design: "content",
      description: "display name of the message author",
  },
  "timestamp": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "string (\"11:24\", \"2 hours ago\") or any node for custom formatting",
  },
  "avatar": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "slot for any `<Avatar>` composition; omit for grouped messages from the same author",
  },
  "badge": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "small chip(s) next to the author name (OP, Bot, Admin, role tag)",
  },
  "edited": {
      schema: z.union([z.boolean(), z.string()]).optional(),
      design: "knob",
      description: "renders \"(edited)\" hint next to timestamp; pass a string to customise (\"(edited 2 minutes ago)\")",
  },
  "pinned": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "renders a pin glyph + \"Pinned\" label above the header row for sticky / pinned messages",
  },
  "actions": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "end-of-header slot, typically hover-revealed icon buttons (reply / react / more)",
  },
  "reactions": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "slot below the body, typically a Row of reaction chips (emoji + count)",
  },
  "threadCount": {
      schema: z.number().optional(),
      design: "knob",
      description: "renders a \"N replies\" link affordance below the body",
  },
  "onThreadClick": {
      schema: z.unknown().optional(),
      design: "event",
      description: "handler for the threadCount affordance",
  },
  "align": {
      schema: z.enum(["start", "end"]).optional(),
      design: "knob",
      description: "`start` (default) puts the avatar on the left; `end` mirrors for \"your messages\" in DM threads",
  },
  "density": {
      schema: z.enum(["default", "compact"]).optional(),
      design: "knob",
      description: "`default` is the canonical chat / channel-feed rhythm; `compact` tightens text sizes + gaps for dense side panels (Studio comments, activity feeds). Pair with `Avatar size=\"xs\"` for the tightest stack.",
  },
  "children": {
      schema: z.unknown(),
      design: "plumbing",
      description: "body content (plain text or rich nodes)",
  },
  "className": {
      schema: z.string().optional(),
      design: "plumbing",
  },
  },
});
